import * as ReactBootstrap from "react-bootstrap";
import {RepairDetailsFormatter} from "../../Repairs";
import Moment from "react-moment";
import React from "react";
import {GSXInformationDeleteButton} from "./GSXInformationDeleteButton";

export const GSXInformation = ({ information, onTicketUpdate,    gsx_repair_types,
    gsx_service_types,ticket }) => {
  const {
    gsx_service_type,
    created_at,
    gsx_repair_type,
    gsx_reference_number,
    comptia_code,

  } = information
  console.log("gsx_repair_types",gsx_repair_types)
  console.log("gsx_service_types",gsx_service_types)
  return (
    <div>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col className={'p-2'} xs="6">
              <strong>
                GSX Reference Number:{' '}
                {RepairDetailsFormatter(gsx_reference_number)}-
              </strong>
              <sub>
                <Moment fromNow>{created_at}</Moment>
              </sub>{' '}
              <br />
              <strong>Comptia Code :</strong>
              {comptia_code}
              <br />
              <strong>Repair Type Code :</strong>
              {gsx_repair_types?.filter(x=>x.code===gsx_repair_type)[0]?.value || gsx_repair_type}
              <br />
              <strong>Repair Coverage Type :</strong>
               {gsx_service_types?.filter(x=>x.code===gsx_service_type)[0]?.value || gsx_service_type}
            </ReactBootstrap.Col>
            <ReactBootstrap.Col className="text-end" xs="6">
              <GSXInformationDeleteButton
                information={information}
                onDelete={(info)=>{
                  onTicketUpdate({...ticket,gsx_information:ticket.gsx_information.filter(x=>x.url!=info.url)})
                }
                }
              />
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </div>
  )
}
